import React, { useState } from "react";
import PageWrapper from "../components/PageWrapper";
import Colors from "../styles/Colors.json";
import { useSiteContext } from "../SiteContext";
import { downloadAttendanceReport } from "../api/attendanceReport";

const AttendanceReportPage: React.FC = () => {
  const { translator, payPeriodID, payPeriods, year, setLoading, createPopup } = useSiteContext();
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    if (!payPeriodID || payPeriodID === 0) {
      createPopup("Error", "Please select a pay period to download the report.");
      return;
    }

    const currentPayPeriod = payPeriods.find((pp) => pp.PayPeriodID === payPeriodID);
    const weekNumber = currentPayPeriod?.WeekNumber ?? 0;

    const parsedYear = parseInt(year, 10);
    const accountingYear =
      currentPayPeriod?.AccountingYear ?? (Number.isNaN(parsedYear) ? new Date().getFullYear() : parsedYear);

    const fileName = `AttendanceReport_Week${weekNumber}_${accountingYear}.xlsx`;

    setIsDownloading(true);
    setLoading(true);

    try {
      await downloadAttendanceReport(payPeriodID, fileName);
    } catch (error) {
      console.error("Error downloading attendance report:", error);
      createPopup("Error", "Failed to download attendance report. Please try again.");
    } finally {
      setIsDownloading(false);
      setLoading(false);
    }
  };

  return (
    <PageWrapper
      title={translator.translate("attendanceReport")}
      backgroundColor={Colors.White}
      weekSelector={true}
    >
      <div style={{ padding: "16px" }}>
        <p>
          Select a pay period using the selector above, then click the button
          below to download the Attendance Report as an Excel file.
        </p>
        <button
          className="report-generate-button"
          onClick={handleDownload}
          disabled={isDownloading || !payPeriodID || payPeriodID === 0}
        >
          {isDownloading ? "Downloading..." : "Download Attendance Report"}
        </button>
      </div>
    </PageWrapper>
  );
};

export default AttendanceReportPage;

